/**
 * axios error에서 페이지 에러 렌더용 정보만 추출한다. (규칙: .claude/rules/error-handling.md)
 * @param {*} error raw axios error — 네트워크 에러(response 없음)면 status는 null
 * @returns {{ status: number|null, message: string }}
 */
const extractApiError = (error) => ({
    status: error?.response?.status ?? null,
    message: error?.response?.data?.message ?? error?.message ?? "",
});

export default extractApiError;
